import { Button, message, Modal, Switch, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { UploadOutlined } from "@ant-design/icons";
import useDocumentUpload from "../../../../hooks/useDocumentUpload";
import AppInput from "../../../../components/AppInput";
import useUserData from "../../../../hooks/useUserData";
import TextArea from "antd/es/input/TextArea";
import { ApiURL } from "../../../../services/apiConstants";
import { post } from "../../../../services/services";
import { ErrorToast, ShowInputError, SuccessToast } from "../../../../widgets/AppToast";
import SelectInput from "../../../../components/SelectInput";

function AddOliRecordLogPartTwoModal({ visible, onClose, onSuccess, parent_id }) {
  const navigate = useNavigate();
  const user = useUserData();
  const designation = user?.data?.designation;
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [code, set_code] = useState("");
  const [date, set_date] = useState(moment().format("YYYY-MM-DD"));
  const [signature, set_signature] = useState("");
  const [codeList, setCodeList] = useState([]);
  const [codeItemList, setCodeItemList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const { documentList, handleDocumentChange, getFilesForUpload } = useDocumentUpload();
  const [previous_log_date, set_Previous_Log_Date] = useState("");

  const LIST_OIL_RECORD_CODE_API = () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("orb_part", "2");
      post(ApiURL.list_code_categories_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRespones = res?.code_categories?.map((item) => {
            return {
              value: item?.id,
              label: `(${item?.value}) ` + item?.label,
            };
          });
          LIST_OIL_RECORD_ITEM_API(newRespones?.[0]?.value);
          setCodeList(newRespones);
          set_Previous_Log_Date(res?.last_record);
        }
      });
    } catch (error) {
      console.error("Error fetching Code list:", error);
    }
  };

  const LIST_OIL_RECORD_ITEM_API = (code_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("code_category_id", code_id);
      FORM_DATA.append("orb_part", "2");
      post(ApiURL.list_subdetails_category_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRes = res?.subdetails?.map((item) => {
            return {
              value: item?.id,
              label: item?.sub_code_name,
              sub_code_name: item?.subdetails_child,
            };
          });
          setCodeItemList(newRes);
        }
      });
    } catch (error) {
      console.error("Error fetching Code Item list:", error);
    }
  };

  const SEND_NOTIFICATION_CHIEF_ENGINEER = async (record_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
      FORM_DATA.append("orb_part", "2");
      FORM_DATA.append("record_id", record_id);
      FORM_DATA.append(
        "description",
        "A new ORB Part 2 record has been created. Please review and confirm it at your earliest convenience"
      );
      const response = await post(ApiURL?.notification_save_req, FORM_DATA);
      if (response?.status === true) {
        SuccessToast("Congratulations!", response?.message || "No message returned.");
      } else {
        ErrorToast("Error", response?.message || "Something went wrong.");
      }
    } catch (error) {
      ErrorToast("Request Failed", "Could not complete the request. Please try again.");
    }
  };

  const ADD_OIL_RECORD_LOGBOOK_APIS = async () => {
    const files = getFilesForUpload();
    set_loader(true);
    const selectedItemsData = selectedItems?.some(
      (item) => item.value === null || item.value === ""
    );
    if (selectedItemsData) {
      set_loader(false);
      return;
    }
    const FORM_DATA = new FormData();
    FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
    FORM_DATA.append("orb_part", "2");
    FORM_DATA.append("code_category_id", code);
    FORM_DATA.append("sub_detail_id", JSON.stringify(selectedItems));
    FORM_DATA.append("sub_detail_values", JSON.stringify(selectedItems));
    FORM_DATA.append("date", date);
    FORM_DATA.append("operation_details", signature);
    FORM_DATA.append("parent_id_for_O", parent_id);
    files?.forEach((files) => {

      FORM_DATA.append("files", files);
    });
    post(ApiURL.add_orb_details_st, FORM_DATA).then((res) => {
      if (res?.status == true) {
        SuccessToast("Congratulation!!", res?.message);
        navigate("/list-oil-record-log");
        onSuccess?.();
        set_loader(false);
        if (designation && designation !== "Chief Officer") {
          SEND_NOTIFICATION_CHIEF_ENGINEER(res?.id);
        }
      } else {
        ErrorToast("Error message", res?.message);
        const errors = res?.response?.data?.errors || {};
        set_errors(errors);
        set_loader(false);
      }
    });
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    LIST_OIL_RECORD_CODE_API();
  }, []);

  const groupedOptions = codeItemList.flatMap((item) => {
    if (item.sub_code_name.length > 0) {
      return {
        label: <p style={{ fontSize: "15px" }}>{item.label}</p>,
        options: item.sub_code_name.map((sub, index) => ({
          value: `${item.value}-${index}`,
          label: ` ${sub?.subdetails_child}`,
        })),
      };
    } else {
      return {
        value: item.value,
        label: item.label,
      };
    }
  });

  const handleCheckboxChange = (value) => {
    setSelectedItems((prevItems) => {
      const exists = prevItems.find((item) => item.id === value);
      if (exists) {
        return prevItems.filter((item) => item.id !== value);
      } else {
        return [...prevItems, { id: value, value: "" }];
      }
    });
  };

  const handleInputChange = (id, inputValue) => {
    setSelectedItems((prevItems) =>
      prevItems?.map((item) => (item.id === id ? { ...item, value: inputValue } : item))
    );
  };

  const getDocUrl = (file) => {
    if (file.url) return file.url; // existing file
    if (file.originFileObj) return URL.createObjectURL(file.originFileObj); // newly uploaded
    return null;
  };

  const handlePreviews = async (file) => {
    const url = getDocUrl(file);
    if (!url) {
      message.error("No preview available for this file");
      return;
    }
    window.open(url, "_blank");
  };

  return (
    <>
      <Modal
        open={visible}
        onCancel={onClose}
        footer={[
          <Button key="cancel" onClick={onClose}>
            Cancel
          </Button>,
          <Button key="save" type="primary" loading={loader} onClick={ADD_OIL_RECORD_LOGBOOK_APIS}>
            Save
          </Button>,
        ]}
        width={1000}
      >
        <div className="white-container">
          <h3 style={{ color: "red", textAlign: "center" }}>Missed Operation Details </h3>

          <br />
          <h3>Oil Record book Part 2 Information</h3>
          <br />
          <div className="row">
            <div className="col-6">
              <SelectInput
                label="Code"
                value={code}
                placeholder=" -- Selecte Code  -- "
                style={{ width: "100%" }}
                onChange={(value) => {
                  set_code(value);
                  setSelectedItems([]);
                  LIST_OIL_RECORD_ITEM_API(value);
                }}
                options={codeList}
                errors={errors?.code_category_id}
              />
            </div>
            <div className="col-6">
              <AppInput
                type="date"
                label="Date"
                placeholder="Date"
                value={date}
                onChange={(e) => set_date(e?.target?.value)}
                errors={errors.date}
                showInfo={code !== 30}
                infoMessage="Original Operation Date"
                // min={previous_log_date}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>
          </div>

          {code && (
            <div
              className="col-12"
              style={{
                lineHeight: "2",
                border: "1px solid #d9d9d9",
                borderRadius: "5px",
              }}
            >
              <strong className="form-label">Select Items:</strong>
              {groupedOptions.map((optionGroup, index) => (
                <div key={index} className="mb-3">
                  {/* Main Label as Checkbox */}
                  <div className="row align-items-center mb-2">
                    <div className="col-6">
                      <div className="form-check">
                        {optionGroup?.options?.length > 1 ? (
                          ""
                        ) : (
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value={optionGroup.label}
                            checked={selectedItems.some((item) => item.id === optionGroup.value)}
                            onChange={() => handleCheckboxChange(optionGroup.value)}
                            id={`group-checkbox-${index}`}
                          />
                        )}
                        <label className="form-check-label" htmlFor={`group-checkbox-${index}`}>
                          {typeof optionGroup.label === "string" ? (
                            <strong>{optionGroup.label}</strong>
                          ) : (
                            <strong>{optionGroup.label.props.children}</strong>
                          )}
                        </label>
                      </div>
                    </div>

                    {/* Input Field for Main Label */}
                    <div className="col-6" style={{ marginLeft: "22px" }}>
                      {selectedItems.some((item) => item.id === optionGroup.value) && (
                        <TextArea
                          required
                          maxLength={1000}
                          className="form-control"
                          autoSize={{ minRows: 1 }}
                          placeholder={
                            typeof optionGroup.label === "string"
                              ? optionGroup.label
                              : optionGroup.label.props.children
                          }
                          value={
                            selectedItems.find((item) => item.id === optionGroup.value)?.value || ""
                          }
                          onChange={(e) => handleInputChange(optionGroup.value, e.target.value)}
                        />
                      )}
                    </div>
                  </div>

                  {/* Sub-options */}
                  {optionGroup.options && (
                    <div className="ms-3" style={{ marginLeft: "30px", padding: "10px" }}>
                      {optionGroup.options.map((option) => (
                        <div key={option.value} className="row align-items-center mb-2">
                          {/* Left Side - Checkbox */}
                          <div className="col-6">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value={option.value}
                                checked={selectedItems.some((item) => item.id === option.value)}
                                onChange={() => handleCheckboxChange(option.value)}
                                id={`checkbox-${option.value}`}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`checkbox-${option.value}`}
                              >
                                {option.label}
                              </label>
                            </div>
                          </div>

                          {/* Right Side - Input Field */}
                          <div className="col-6" style={{ padding: "5px" }}>
                            {selectedItems.some((item) => item.id === option.value) && (
                              <TextArea
                                required
                                maxLength={1000}
                                className="form-control"
                                autoSize={{ minRows: 3 }}
                                placeholder={option.label}
                                value={
                                  selectedItems.find((item) => item.id === option.value)?.value ||
                                  ""
                                }
                                onChange={(e) => handleInputChange(option.value, e.target.value)}
                              />
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

          {errors.sub_detail_values && <ShowInputError errorMessage={errors.sub_detail_values} />}

          <div className="row" style={{ paddingTop: "10px" }}>
            <div className="col-6">
              <AppInput
                label="Name of operation incharge"
                placeholder="Name of operation incharge"
                value={signature}
                onChange={(e) => set_signature(e.target.value)}
                errors={errors.operation_details}
                showInfo={code !== 30}
                infoMessage="Signatur of In-charge (or C/E if signed off)"
              />
            </div>
            <div className="col-6">
              <div
                className="input-box"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  alignItems: "flex-start",
                }}
              >
                <label>Select File</label>
                <Upload
                  accept=".pdf,.doc,.docx,.xls,.xlsx"
                  multiple
                  fileList={documentList}
                  onChange={handleDocumentChange}
                  onPreview={handlePreviews}
                  beforeUpload={() => false}
                  listType="picture"
                >
                  <Button
                    icon={<UploadOutlined />}
                    type="primary"
                    style={{
                      borderRadius: "50%",
                      padding: "10px",
                      width: "40px",
                      height: "40px",
                      marginLeft: "10px",
                    }}
                  ></Button>
                </Upload>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default AddOliRecordLogPartTwoModal;
